export default __webpack_public_path__ + "static/media/img_tutorial_main_bg.59833688.png";